import { AdminUrlLinks } from 'components/SACollection/types'
import { createSelector } from 'reselect'
import { getPageParams } from 'selectors/page'
import { getUserID } from 'selectors/user/session'
import { urlQuery } from '../helpers/url'

export const getOwnerId = createSelector(getPageParams, (params): string => params.ownerId || '')

export const getCollectionId = createSelector(
  getPageParams,
  (params): string => params.collectionId || 0
)

export const getUserCollectionsUrl = createSelector([getUserID], (userId): string => {
  return `/account/collection/${userId}`
})

export const getTitle = createSelector(getPageParams, (params): string => params.title || '')

export const getUrlPathString = createSelector(
  [getCollectionId, getOwnerId, getTitle],
  (collectionId, ownerId, title): string =>
    `/art-collection/${title}/${ownerId}/${collectionId}/view`
)

export const getCollectionEditUrl = createSelector(
  [getCollectionId, getOwnerId, getTitle],
  (collectionId, ownerId, title): string =>
    `/art-collection/${title}/${ownerId}/${collectionId}/edit/`
)

export const getAdminUrlLinks = createSelector(
  [getCollectionId, getOwnerId, getUserCollectionsUrl, getCollectionEditUrl, getUrlPathString],
  (collectionId, ownerId, collectionsUrl, collectionEditUrl, viewCollectionUrl): AdminUrlLinks => ({
    createCollectionUrl: '/collections/create',
    deleteCollectionUrl: `/collections/delete/collection/${collectionId}/owner/${ownerId}`,
    duplicateCollectionUrl: `/collections/duplicate/${ownerId}/${collectionId}`,
    editCollectionUrl: collectionEditUrl,
    collectionExportCSVUrl: `/collections/get-collection-artist-emails/owner/${ownerId}/collection/${collectionId}`,
    reorderUrl: `/collections/reorder/owner/${ownerId}/collection/${collectionId}`,
    collectionsUrl,
    viewCollectionUrl,
  })
)

export const getUrlStringWithParams = (params: Record<string, any>) =>
  createSelector([getUrlPathString], (urlPathString): string => {
    const queryParams = params
    const queryString = urlQuery(queryParams)
    return `${urlPathString}${queryString}`
  })
